import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly activeLoadCount = signal(0);
  private readonly activeLoadingText = signal<string>('');
  readonly isLoading = computed(() => this.activeLoadCount() > 0);
  readonly loadingText = computed(() => this.activeLoadingText());

  setLoading(loading: boolean): void {
    this.activeLoadCount.set(loading ? 1 : 0);
    if (!loading) {
      this.activeLoadingText.set('');
    }
  }

  showGlobalLoading(show: boolean, loadingText = ''): void {
    if (show) {
      if (loadingText.trim().length > 0) {
        this.activeLoadingText.set(loadingText);
      }
      this.show();
      return;
    }

    this.hide();
  }

  setLoadingText(loadingText: string): void {
    this.activeLoadingText.set(loadingText.trim());
  }

  show(): void {
    this.activeLoadCount.update((count) => count + 1);
  }

  hide(): void {
    this.activeLoadCount.update((count) => {
      const next = Math.max(0, count - 1);
      if (next === 0) {
        this.activeLoadingText.set('');
      }
      return next;
    });
  }
}
